import { Head } from '@inertiajs/react';
import { AttendeesList } from '@/components/attendees/attendees-list';
import type { MentorAttendeesShow } from '@/types';

// /:event_slug/mentor/attendees — the on-site directory, which only Bogotá ships.
export default function Show({
  title,
  eventName,
  attendees,
}: MentorAttendeesShow) {
  return (
    <>
      <Head title={title} />
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-12 md:py-16">
          <div className="mx-auto w-full max-w-5xl space-y-8">
            <div>
              <h1 className="font-bold font-title text-3xl text-primary sm:text-4xl">
                Asistentes
              </h1>
              <p className="mt-2 font-mono text-primary/70 text-sm">
                {eventName}
              </p>
            </div>

            <AttendeesList attendees={attendees} />
          </div>
        </div>
      </div>
    </>
  );
}
